import type { FirstTaskRewardAction } from './first-task-reward-api';

/** 权益卡片的展示文案。 */
export interface FirstTaskRewardPromptCopy {
    /** 标题。 */
    title: string;
    /** 奖励说明前缀。 */
    benefitPrefix: string;
    /** 高亮积分文案。 */
    credits: string;
    /** 奖励说明后缀。 */
    benefitSuffix: string;
    /** 导出按钮。 */
    exportNow: string;
    /** 分享按钮。 */
    shareNow: string;
    /** 有效期说明。 */
    validity: string;
    /** 关闭按钮无障碍文案。 */
    closeLabel: string;
}

/** 权益卡片展示参数。 */
export interface FirstTaskRewardPromptOptions extends FirstTaskRewardPromptCopy {
    /** 用户选择奖励动作。 */
    onAction(action: FirstTaskRewardAction): void;
    /** 用户主动关闭卡片。 */
    onDismiss(): void;
}

/** 动态挂载 UI 的幂等句柄。 */
export interface FirstTaskRewardPresenterHandle {
    /** 立即卸载 UI 并清理监听。 */
    dispose(): void;
}

/** 权益卡片的动态交互句柄。 */
export interface FirstTaskRewardPromptHandle extends FirstTaskRewardPresenterHandle {
    /** 设置正在等待完成的动作；不传值时恢复全部按钮。 */
    setActionLoading(action?: FirstTaskRewardAction): void;
}

/** 首次任务奖励独立 UI presenter。 */
export interface FirstTaskRewardPresenter {
    /** 将权益卡片挂载到 document.body。 */
    showPrompt(options: FirstTaskRewardPromptOptions): FirstTaskRewardPromptHandle;
}

export const FirstTaskRewardPresenter = Symbol('FirstTaskRewardPresenter');
